const data: string = "<div ng-if=\"overdraftSummary && isActiveGracePeriod()\" cms-html=\"grace-period-message:components/overdraft-domain\"></div>";
export default data